import { commitMutation, graphql } from 'react-relay';

const mutation = graphql`
    mutation FollowingsShownMutation(
    $input: FollowingsShownInput!
    ) {
        followingsShown(input: $input) {
            clientMutationId
        }
    }
`;


function followingsShown({ environment, ids }) {
    return commitMutation(
        environment, {
            mutation,
            variables: {
                input: { ids }
            }
        }
    );
}

export default { commit: followingsShown };



// WEBPACK FOOTER //
// ./src/components/FavNotifications/FollowingsShown.js